import { render } from "./ChartWrapper.vue?vue&type=template&id=cdc9713c&ts=true"
import script from "./ChartWrapper.vue?vue&type=script&lang=ts"
export * from "./ChartWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/ChartWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cdc9713c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cdc9713c', __exports__)) {
    console.log('reload')
    api.reload('cdc9713c', __exports__)
  }
  
  module.hot.accept("./ChartWrapper.vue?vue&type=template&id=cdc9713c&ts=true", () => {
    console.log('re-render')
    api.rerender('cdc9713c', render)
  })

}


export default __exports__